import { render, staticRenderFns } from "./DefContex.vue?vue&type=template&id=7537448d&"
import script from "./DefContex.vue?vue&type=script&lang=ts&"
export * from "./DefContex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports